import { createSelector } from 'reselect';
import { getProjectListState } from 'src/modules/project-list/selectors/getProjectListState';

export const getProjectListRemoving = createSelector([
  getProjectListState,
], (state) => state.removing);
